import * as React from "react";
export const CommentHollowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 21 19.7" {...props}>
    <path
      d="M3.4 19.7v-5.5a7.29 7.29 0 01-3.4-6C0 3.7 4.7 0 10.5 0S21 3.7 21 8.2s-4.7 8.2-10.5 8.2h-1zM10.5 2C5.8 2 2 4.8 2 8.2a5.72 5.72 0 003 4.7l.5.3v3.2l3.6-2h.3c.4 0 .8.1 1.2.1 4.7 0 8.5-2.8 8.5-6.2S15.2 2 10.5 2z"
      fill="#979797"
    />
  </svg>
);
